export default function () {
    return (
        <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_7177_94576)">
                <path
                    d="M27.8 6.5H4.2C3.53726 6.5 3 7.03726 3 7.7V22.3C3 22.9627 3.53726 23.5 4.2 23.5H27.8C28.4627 23.5 29 22.9627 29 22.3V7.7C29 7.03726 28.4627 6.5 27.8 6.5Z"
                    stroke="black"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M25.6 9.5H6.4C6.17909 9.5 6 9.67909 6 9.9V20.1C6 20.3209 6.17909 20.5 6.4 20.5H25.6C25.8209 20.5 26 20.3209 26 20.1V9.9C26 9.67909 25.8209 9.5 25.6 9.5Z"
                    stroke="black"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 26.2988L8.5 23.7008" stroke="black" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M25.5 26.2988L24 23.7008" stroke="black" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_7177_94576">
                    <rect width="32" height="32" fill="white" transform="translate(0 0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
}
